module.exports = __webpack_public_path__ + "static/media/lucky-new-year.a7ac96d0.gif";